import LegalPage from "../../components/legal/LegalPage";
import document from "../../content/legal/online-safety-policy.json";

export default function Page() {
  return <LegalPage title="Online Safety Policy" document={document} />;
}
